let _utterance: null | SpeechSynthesisUtterance;

// Matches a `.ca` URL, capturing the host (group 1) and optional path (group 2).
// The protocol is matched but not captured, so it's dropped from the result. The
// trailing `\b` avoids longer TLDs like `.cat`; `.com` and "e.g." are untouched.
const CA_URL_TOKEN = /\b(?:https?:\/\/)?((?:www\.)?[\w-]+\.ca)\b(\/[^\s,]*)?/gi;

// The custom TTS engine (`overrideAria` platforms) mistakes `.ca` URLs:
// ".ca" is read as "kaa" and slashes are dropped. Rewrite each `.ca` URL into
// spoken words, e.g. "crave.ca/begin" -> "crave dot C A slash begin". Other text
// is returned unchanged.
export function spellCaUrlsInText(text: string): string {
  return text.replace(CA_URL_TOKEN, (_match, host, path = '') => {
    // "www.crave.ca" -> "www dot crave dot C A" (dots spoken, TLD spelled out)
    const spokenHost = host.replace(/\.ca$/i, '.C A').split('.').join(' dot ');

    // "/begin" -> " slash begin" so the slash is spoken instead of dropped
    const spokenPath = path
      .split('/')
      .filter(Boolean)
      .map((segment: string) => ` slash ${segment}`)
      .join('');

    return `${spokenHost}${spokenPath}`;
  });
}

export const TTS = {
  init: () => {
    _utterance = new window.SpeechSynthesisUtterance();
  },
  speak: (text: string) => {
    window.speechSynthesis.cancel(); // Stop any ongoing speech
    if (_utterance) {
      // Spell `.ca` URLs into words so they aren't mistaken (e.g. "crave kaa")
      _utterance.text = spellCaUrlsInText(text);
      window.speechSynthesis.speak(_utterance);
    }
  },
  cancel: () => {
    window.speechSynthesis.cancel();
  },
};
